// extracted by mini-css-extract-plugin
export var searchHeader = "_31-0";
export var searchHeaderDark = "_31-1";